import { Component, EventEmitter, HostListener, Input, Output } from "@angular/core";
import { CommonModule } from "@angular/common";
import { IonicModule } from "@ionic/angular";
import { ModalService } from "@services/modal/modal.service";

export interface TramitePensionStep {
  numero: number;
  titulo: string;
  descripcion: string;
}

@Component({
  selector: "app-modal-pasos-tramite-pension",
  templateUrl: "./modal-pasos-tramite-pension.component.html",
  styleUrl: "./modal-pasos-tramite-pension.component.scss",
  standalone: true,
  imports: [CommonModule, IonicModule],
})
export class ModalPasosTramitePensionComponent {
  @Input() titulo: string = "¿Qué pasos debes seguir para completar tu solicitud en línea?";
  @Input() descripcion: string =
    "Te contamos los pasos para realizar la solicitud en línea:";

  @Input() pasos: TramitePensionStep[] = [];

  @Input() textoBotonPrimario: string = "Ir a la solicitud";

  @Output() primaryAction = new EventEmitter<void>();

  isScrolled = false;

  constructor(private readonly modalService: ModalService) {}

  @HostListener("document:keydown.escape")
  onEscapeKey(): void {
    this.cerrar();
  }

  cerrar(): void {
    this.modalService.closeModal();
  }

  onPrimaryClick(): void {
    this.primaryAction.emit();
    this.cerrar();
  }

  onScroll(event: Event): void {
    const target = event.target as HTMLElement;
    // Activa sombra en el header cuando el contenido se desplaza
    this.isScrolled = target.scrollTop > 0;
  }
}

